/**
 * 小爱登录
 */
import request from '@/router/axios'

export const getCode = (phone) => {
  return  request({
    method: 'GET',
    url: `miui/iot/oauth/get_code`,
    params: phone
  })
}

export const login = (data) => {
  return  request({
    method: 'POST',
    url: `miui/iot/oauth/login`,
    data: data
  })
}




// WEBPACK FOOTER //
// ./src/api/login.js